import React, { useEffect } from 'react';

const InstagramFeedNew = () => {
  useEffect(() => {
    const scriptSrc = 'https://elfsightcdn.com/platform.js';
    let script = document.querySelector(`script[src="${scriptSrc}"]`);

    if (!script) {
      script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-16 md:py-20 bg-gradient-to-b from-stone-100/50 via-warm-beige/30 to-stone-50 dark:from-stone-900/60 dark:to-stone-950 border-t border-stone-200/60 dark:border-stone-800 transition-colors duration-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Elfsight Instagram Feed | Oana Tenea */}
        <div
          className="elfsight-app-8ccc59ac-6239-4c15-9c11-1066a4070eab"
          data-elfsight-app-lazy
        />
      </div>
    </section>
  );
};

export default InstagramFeedNew;
